import { render } from "./ProductGridItem.vue?vue&type=template&id=00251e64"
import script from "./ProductGridItem.vue?vue&type=script&lang=js"
export * from "./ProductGridItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__